import { cn as e } from "../shared/utils.js";
import { Checkbox as t } from "../checkbox/primitive/index.js";
import { OverflowProvider as n } from "../shared/overflow/overflow-context.js";
import { useOverflowContainer as r } from "../shared/overflow/use-overflow-container.js";
import { useOverflowItem as i } from "../shared/overflow/use-overflow-item.js";
import { useOverflowMenu as a } from "../shared/overflow/use-overflow-menu.js";
import { CheckIcon as o, PlusIcon as s, XCloseIcon as c } from "@systemeio/icons";
import * as l from "react";
import { forwardRef as u } from "react";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import { cva as m } from "class-variance-authority";
import { Field as h } from "@base-ui/react/field";
import { Select as g } from "@base-ui/react/select";
//#region src/select/select-primitive.tsx
var _ = m([
	"group/select-trigger flex w-full min-w-0 items-center justify-between gap-0.5 rounded-md border border-field-border bg-field-bg-primary text-left text-text-primary outline-none transition-base text-base",
	"data-[size=md]:px-3 data-[size=sm]:px-2",
	"placeholder:text-text-tertiary",
	"data-popup-open:border-field-border-active data-popup-open:shadow-field-border-active",
	"focus-visible:border-field-border-active focus-visible:shadow-field-border-active",
	"hover:border-field-border-hover",
	"data-disabled:bg-field-bg-disabled data-disabled:text-text-disabled data-disabled:placeholder:text-text-disabled data-disabled:cursor-not-allowed",
	"data-invalid:border-field-border-error data-invalid:shadow-field-border-error",
	"data-invalid:focus-visible:border-field-border-error data-invalid:focus-visible:shadow-field-border-error",
	"data-invalid:data-popup-open:border-field-border-error data-invalid:data-popup-open:shadow-field-border-error",
	"data-warning:border-border-warning data-warning:shadow-field-border-warning",
	"data-warning:focus-visible:border-border-warning data-warning:focus-visible:shadow-field-border-warning",
	"data-warning:data-popup-open:border-border-warning data-warning:data-popup-open:shadow-field-border-warning",
	"has-data-[overflow-mode=expanded]:h-auto has-data-[overflow-mode=expanded]:items-start",
	"data-group-control:h-full data-group-control:min-w-0 data-group-control:flex-1 data-group-control:rounded-none data-group-control:border-0 data-group-control:bg-transparent data-group-control:shadow-none",
	"[&>svg:not([class*=size-])]:size-5"
], {
	variants: { size: {
		sm: "h-8 min-h-8 py-1.5 has-data-[overflow-mode=collapsed]:py-1 has-data-[overflow-mode=expanded]:min-h-8 has-data-[overflow-mode=expanded]:py-[calc(0.25rem-1px)]",
		md: "h-10 min-h-10 py-2.5 has-data-[overflow-mode=collapsed]:py-2 has-data-[overflow-mode=expanded]:min-h-10 has-data-[overflow-mode=expanded]:py-[calc(0.5rem-1px)]"
	} },
	defaultVariants: { size: "md" }
}), v = l.createContext(!1);
function y(e) {
	return /* @__PURE__ */ f(v.Provider, {
		value: !!e.multiple,
		children: /* @__PURE__ */ f(g.Root, { ...e })
	});
}
var b = u(({ className: t, required: n, ...r }, i) => /* @__PURE__ */ f(g.Label, {
	ref: i,
	"data-slot": "select-label",
	"data-testid": "select-label",
	"data-required": n || void 0,
	className: e("text-text-secondary data-required:after:text-text-error flex items-start text-base font-normal data-required:after:ml-0.5 data-required:after:content-['*']", t),
	...r
})), x = m("text-base", {
	variants: { tone: {
		default: "text-text-tertiary",
		warning: "text-text-warning"
	} },
	defaultVariants: { tone: "default" }
}), S = u(({ className: t, tone: n, ...r }, i) => /* @__PURE__ */ f("p", {
	ref: i,
	"data-slot": "select-description",
	"data-testid": "select-description",
	className: e(x({ tone: n }), t),
	...r
}));
S.displayName = "SelectPrimitive.Description";
var C = u(({ className: t, ...n }, r) => /* @__PURE__ */ f("p", {
	ref: r,
	"data-slot": "select-error",
	"data-testid": "select-error",
	role: "alert",
	className: e("text-text-error text-base", t),
	...n
}));
C.displayName = "SelectPrimitive.Error";
var w = u(({ className: t, size: n = "md", unstyled: r, ...i }, a) => r ? /* @__PURE__ */ f(g.Trigger, {
	ref: a,
	"data-slot": "select-trigger",
	"data-testid": "select-trigger",
	"data-unstyled": "",
	className: t,
	...i
}) : /* @__PURE__ */ f("div", {
	"data-slot": "select-trigger-shell",
	"data-testid": "select-trigger-shell",
	"data-size": n,
	className: "relative w-full min-w-0",
	children: /* @__PURE__ */ f(g.Trigger, {
		ref: a,
		"data-slot": "select-trigger",
		"data-testid": "select-trigger",
		"data-size": n,
		className: e(_({ size: n }), t),
		...i
	})
})), T = u(({ className: t, ...n }, r) => /* @__PURE__ */ f("div", {
	ref: r,
	"data-slot": "select-field",
	"data-testid": "select-field",
	className: e("group/select-group group-focus-ring transition-base bg-field-bg-primary relative inline-flex w-full min-w-0 items-center rounded-md outline-none", "has-data-disabled:bg-field-bg-disabled", t),
	...n
}));
T.displayName = "SelectPrimitive.Field";
var E = u(({ className: t, children: n, description: r, ...i }, a) => /* @__PURE__ */ p("div", {
	ref: a,
	"data-slot": "select-empty",
	"data-testid": "select-empty",
	className: e("flex flex-col items-start gap-1 px-3 py-4", t),
	...i,
	children: [r != null && r !== "" && /* @__PURE__ */ f("span", {
		"data-slot": "select-empty-description",
		"data-testid": "select-empty-description",
		className: "text-text-disabled w-full text-sm",
		children: r
	}), n != null && n !== "" && /* @__PURE__ */ f("span", {
		"data-slot": "select-empty-title",
		"data-testid": "select-empty-title",
		className: "text-text-primary w-full text-base",
		children: n
	})]
}));
E.displayName = "SelectPrimitive.Empty";
var D = u(({ className: t, ...n }, r) => /* @__PURE__ */ f(g.Value, {
	ref: r,
	"data-slot": "select-value",
	"data-testid": "select-value",
	className: e("text-text-primary data-placeholder:text-text-tertiary group-data-disabled/select-trigger:text-text-disabled line-clamp-1 min-w-0 flex-1 text-left text-base", t),
	...n
})), O = u(({ className: t, ...n }, r) => /* @__PURE__ */ f(g.Icon, {
	ref: r,
	"data-slot": "select-icon",
	"data-testid": "select-icon",
	className: e("text-field-icon group-data-disabled/select-trigger:text-text-disabled flex size-5 shrink-0 items-center justify-center transition-transform duration-200 ease-out data-popup-open:rotate-180 [&>svg]:size-5", t),
	...n
})), k = g.Portal, A = u(({ className: t, ...n }, r) => /* @__PURE__ */ f(g.Backdrop, {
	ref: r,
	"data-slot": "select-backdrop",
	"data-testid": "select-backdrop",
	className: e("bg-alpha-gray-alpha-gray-25 fixed inset-0 z-40 opacity-0 transition-opacity data-open:opacity-100", t),
	...n
})), j = u(({ className: t, sideOffset: n = 4, alignItemWithTrigger: r = !1, ...i }, a) => /* @__PURE__ */ f(g.Positioner, {
	ref: a,
	"data-slot": "select-positioner",
	"data-testid": "select-positioner",
	sideOffset: n,
	alignItemWithTrigger: r,
	className: e("z-50 outline-none", t),
	...i
})), M = u(({ className: t, ...n }, r) => /* @__PURE__ */ f(g.Popup, {
	ref: r,
	"data-slot": "select-popup",
	"data-testid": "select-popup",
	className: e("bg-bg-primary text-text-primary border-border-100 shadow-1 rounded-md border py-1 outline-none", "flex max-h-[min(268px,var(--available-height))] w-(--anchor-width) min-w-[160px] flex-col overflow-hidden", "data-starting-style:scale-95 data-starting-style:opacity-0", "data-ending-style:scale-95 data-ending-style:opacity-0", "origin-(--transform-origin) transition-[transform,opacity] duration-100 ease-out", t),
	...n
})), N = u(({ className: t, ...n }, r) => /* @__PURE__ */ f(g.List, {
	ref: r,
	"data-slot": "select-list",
	"data-testid": "select-list",
	className: e("min-h-0 flex-1 overflow-y-auto overscroll-contain", "*:data-[slot='select-group']:flex *:data-[slot='select-group']:flex-col *:data-[slot='select-group']:gap-0", t),
	...n
})), P = m([
	"group relative flex w-full min-w-0 cursor-pointer flex-row items-center px-4 py-3 text-base outline-none select-none",
	"text-text-primary hover:bg-bg-tertiary data-highlighted:bg-bg-tertiary data-selected:bg-bg-accent-light",
	"data-disabled:text-text-disabled data-disabled:cursor-not-allowed",
	"[&>svg:not([class*=size-])]:size-5"
], {
	variants: { multiple: {
		true: "gap-2",
		false: "gap-1"
	} },
	defaultVariants: { multiple: !1 }
}), F = u(({ className: t, ...n }, r) => {
	let i = l.useContext(v);
	return /* @__PURE__ */ f(g.Item, {
		ref: r,
		"data-slot": "select-item",
		"data-testid": "select-item",
		className: e(P({ multiple: i }), t),
		...n
	});
}), I = u(({ className: t, ...n }, r) => /* @__PURE__ */ f(g.ItemText, {
	ref: r,
	"data-slot": "select-item-text",
	"data-testid": "select-item-text",
	className: e("line-clamp-2 min-w-0 flex-1", "[&_svg:not([class*=size-])]:size-5", t),
	...n
})), L = u(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ f(g.ItemIndicator, {
	ref: i,
	"data-slot": "select-item-indicator",
	"data-testid": "select-item-indicator",
	className: e("flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", "transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0", t),
	...r,
	children: n ?? /* @__PURE__ */ f(o, {})
})), R = u(({ className: t, ...n }, r) => /* @__PURE__ */ f(g.Group, {
	ref: r,
	"data-slot": "select-group",
	"data-testid": "select-group",
	className: e("flex flex-col gap-0", t),
	...n
})), z = u(({ className: t, ...n }, r) => /* @__PURE__ */ f(g.GroupLabel, {
	ref: r,
	"data-slot": "select-group-label",
	"data-testid": "select-group-label",
	className: e("text-text-tertiary flex w-full items-center justify-center pt-3 text-xs font-normal uppercase", t),
	...n
})), B = u(({ className: t, ...n }, r) => /* @__PURE__ */ f(g.Separator, {
	ref: r,
	"data-slot": "select-separator",
	"data-testid": "select-separator",
	className: e("bg-border-100 mx-3 h-px shrink-0", t),
	...n
})), V = u(({ className: t, mode: i = "collapsed", padding: a = 4, ...o }, s) => {
	let c = i === "fixed", l = c || i === "collapsed" ? "collapsed" : "expanded", { containerRef: u, contextValue: d } = r({ padding: a });
	return /* @__PURE__ */ f(n, {
		value: d,
		children: /* @__PURE__ */ f("div", {
			ref: (e) => {
				u.current = e, typeof s == "function" ? s(e) : s && (s.current = e);
			},
			"data-slot": "select-chips",
			"data-testid": "select-chips",
			"data-overflow-mode": l,
			"data-multi-layout": c ? "fixed" : void 0,
			className: e("flex min-w-0 flex-1 items-center gap-1", l === "collapsed" ? "flex-nowrap overflow-hidden" : "flex-wrap", t),
			...o
		})
	});
});
V.displayName = "SelectPrimitive.Chips";
var H = m(["inline-flex shrink-0 items-center gap-1.5 self-center rounded-full bg-palette-blue-bg px-2.5 py-1 text-sm font-normal whitespace-nowrap text-palette-blue-textandicon", "[&>svg:not([class*=size-])]:size-4"], {
	variants: { variant: {
		tag: "",
		ghost: "bg-transparent text-text-primary"
	} },
	defaultVariants: { variant: "tag" }
}), U = u(({ className: t, variant: n, id: r, ...a }, o) => {
	let s = i(r);
	return /* @__PURE__ */ f("span", {
		ref: (e) => {
			s.current = e, typeof o == "function" ? o(e) : o && (o.current = e);
		},
		"data-slot": "select-chip",
		"data-testid": "select-chip",
		"data-variant": n,
		className: e(H({ variant: n }), t),
		...a
	});
});
U.displayName = "SelectPrimitive.Chip";
var W = u(({ className: t, onClick: n, onMouseDown: r, ...i }, a) => {
	let o = (e) => {
		e.stopPropagation(), e.preventBaseUIHandler?.();
	};
	return /* @__PURE__ */ f("span", {
		ref: a,
		role: "button",
		tabIndex: -1,
		"data-slot": "select-chip-remove",
		"data-testid": "select-chip-remove",
		onClick: (e) => {
			o(e), n?.(e);
		},
		onMouseDown: (e) => {
			o(e), r?.(e);
		},
		className: e("text-palette-blue-textandicon hover:bg-palette-blue-textandicon/10 -m-1 flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full p-1 outline-none [&>svg]:size-4", t),
		...i,
		children: /* @__PURE__ */ f(c, {})
	});
});
W.displayName = "SelectPrimitive.ChipRemove";
var G = u(({ className: t, children: n, onClick: r, onMouseDown: i, ...o }, s) => {
	let { ref: c, overflowCount: l, isOverflowing: u } = a(), d = (e) => {
		c.current = e, typeof s == "function" ? s(e) : s && (s.current = e);
	}, p = (e) => {
		e.stopPropagation(), e.preventBaseUIHandler?.();
	}, m = r != null, h = !u;
	return /* @__PURE__ */ f("span", {
		ref: d,
		"data-slot": "select-overflow-badge",
		"data-testid": "select-overflow-badge",
		"aria-hidden": h || void 0,
		style: h ? { visibility: "hidden" } : void 0,
		onClick: m ? (e) => {
			p(e), r?.(e);
		} : void 0,
		onMouseDown: (e) => {
			m && p(e), i?.(e);
		},
		className: e("text-text-link inline-flex shrink-0 cursor-pointer items-center gap-0.5 self-center rounded-[48px] px-2 py-1 text-sm font-medium select-none", t),
		...o,
		children: n ?? `+${l}`
	});
});
G.displayName = "SelectPrimitive.OverflowBadge";
var K = u(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ f("span", {
	ref: i,
	"data-slot": "select-leading-icon",
	"data-testid": "select-leading-icon",
	"aria-hidden": "true",
	className: e("text-text-tertiary inline-flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", t),
	...r,
	children: n
}));
K.displayName = "SelectPrimitive.LeadingIcon";
var q = u(({ className: n, checked: r = !1, ...i }, a) => /* @__PURE__ */ f(h.Root, {
	className: "contents",
	children: /* @__PURE__ */ f(t.Root, {
		ref: a,
		"data-slot": "select-item-checkbox",
		"data-testid": "select-item-checkbox",
		checked: r,
		size: "md",
		tabIndex: -1,
		"aria-hidden": !0,
		className: e("pointer-events-none", n),
		...i,
		children: /* @__PURE__ */ f(t.Indicator, { size: "md" })
	})
}));
q.displayName = "SelectPrimitive.ItemCheckbox";
var J = u(({ className: t, onClick: n, onMouseDown: r, children: i, ...a }, o) => {
	let s = (e) => {
		e.stopPropagation(), e.preventBaseUIHandler?.();
	};
	return /* @__PURE__ */ f("span", {
		ref: o,
		role: "button",
		tabIndex: -1,
		"data-slot": "select-clear",
		"data-testid": "select-clear",
		onClick: (e) => {
			s(e), n?.(e);
		},
		onMouseDown: (e) => {
			s(e), r?.(e);
		},
		className: e("text-field-icon hover:text-icon-primary flex size-5 shrink-0 cursor-pointer items-center justify-center outline-none [&>svg]:size-5", t),
		...a,
		children: i ?? /* @__PURE__ */ f(c, {})
	});
});
J.displayName = "SelectPrimitive.Clear";
var Y = u(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ f("div", {
	ref: i,
	"data-slot": "select-popup-action",
	"data-testid": "select-popup-action",
	className: e("border-border-100 text-text-link flex items-center gap-2 border-t px-4 py-3 text-base font-medium", t),
	...r,
	children: n ?? /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f(s, { className: "size-5" }), "Button"] })
}));
Y.displayName = "SelectPrimitive.PopupAction", b.displayName = "SelectPrimitive.Label", w.displayName = "SelectPrimitive.Trigger", D.displayName = "SelectPrimitive.Value", O.displayName = "SelectPrimitive.Icon", A.displayName = "SelectPrimitive.Backdrop", j.displayName = "SelectPrimitive.Positioner", M.displayName = "SelectPrimitive.Popup", N.displayName = "SelectPrimitive.List", F.displayName = "SelectPrimitive.Item", I.displayName = "SelectPrimitive.ItemText", L.displayName = "SelectPrimitive.ItemIndicator", R.displayName = "SelectPrimitive.Group", z.displayName = "SelectPrimitive.GroupLabel", B.displayName = "SelectPrimitive.Separator";
var X = {
	Root: y,
	Label: b,
	Description: S,
	Error: C,
	Trigger: w,
	Field: T,
	Value: D,
	Icon: O,
	Portal: k,
	Backdrop: A,
	Positioner: j,
	Popup: M,
	PopupAction: Y,
	List: N,
	Item: F,
	ItemText: I,
	ItemIndicator: L,
	Empty: E,
	Group: R,
	GroupLabel: z,
	Separator: B,
	Chips: V,
	Chip: U,
	ChipRemove: W,
	OverflowBadge: G,
	LeadingIcon: K,
	ItemCheckbox: q,
	Clear: J
};
//#endregion
export { X as SelectPrimitive, H as selectChipVariants, x as selectDescriptionVariants, P as selectItemVariants, _ as selectTriggerVariants };
